import React, { useRef, useState } from "react";

import {
    Grid,
    Container,
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Divider,
    Typography,
} from "@material-ui/core/";
import CloseIcon from "@material-ui/icons/Close";
import Star from "@material-ui/icons/Star";
import Check from "@material-ui/icons/Check";
import SeatPicker from "react-seat-picker";

import { Content, ContainerBox } from "./styles";
import Label from "../../../components/Label";
import Btn from "../../../components/Button";

import { useReactToPrint } from "react-to-print";
import EventApi from "../../../services/event";
import { config } from "../../../config";
import Loading from "../../../components/Loading";
import { getFirstAndLastNames } from "../../../utils/Functions";

const TotemResult = (props) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [person, setPerson] = useState({});
    const [status, setStatus] = useState({});
    const [rows, setRows] = useState(props.data.rows);
    const [dialogPrintOpen, setDialogPrintOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => closeAll(),
    });

    const closeAll = () => {
        setIsLoading(false);
        handleClosePrint();
        props.close();
    };

    const handleClosePrint = () => {
        setDialogPrintOpen(false);
    };

    const event = props.data.event;
    // console.log(props.data.status.find(e=>{return e?.name === 'SHOWED_UP'}).id)
    console.log(props.data.status);

    const SHOWED_UP_ID = 5; //props.data.status.find(e=>{return e?.name === 'SHOWED_UP'}).id || 5;

    const onClick = (event, person) => {
        event.preventDefault();
        setPerson(person);
        // markPosition(person.position_id);
        console.log(person);
        setStatus(
            props.data.status.find((e) => {
                return e?.name === "SHOWED_UP";
            })
        );
        console.log(status);
        setDialogOpen(true);
    };

    const handleClose = () => {
        setDialogOpen(false);
        setRows(props.data.rows);
        props.close();
    };

    const updateCredential = async () => {
        setIsLoading(true);
        await EventApi.updatePerson(person.id, {
            ...person,
            credential_generated: true,
            event_days_attended: person?.event_days_attended
                ? person?.event_days_attended
                : [`${new Date().getDate()}`],
            event_days_subscribed: ["*"],
        });
        setIsLoading(false);
    };

    // const markPosition = (id) => {
    //     setRows(rows.map(col => { return col.map(pos => {
    //         if (pos) {
    //             if (pos.id === id)
    //                 return { ...pos, isSelected: true, isReserved: false }
    //         }
    //         return pos
    //     })}))
    // }

    const printDialog = (
        <>
            <Dialog onClose={handleClosePrint} open={dialogPrintOpen}>
                <ContainerBox className="content">
                    <DialogContent style={{ minWidth: "400px", maxHeight: "400px" }}>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Imprimir Tag para {person.name}
                        </Label>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid id="teste" item md={12} style={{ width: "100%" }}>
                                <div
                                    ref={componentRef}
                                    id="to_pdf"
                                    className="card border-0"
                                    // style={{ width: "240px", height: "120px", border: "none" }}
                                    style={{ width: "280px", height: "110px", border: "none" }}
                                >
                                    <div
                                        className="row"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            height: "100%",
                                        }}
                                    >
                                        <div className="col-sm-5">
                                            <div className="text-center">
                                                <img
                                                    src={`${config.QRCODE_HOST}/?size=95x95&data=${person.id}`}
                                                    alt={`${person.id}`}
                                                    className="card-img-top"
                                                    style={{
                                                        paddingTop: "2px",
                                                        paddingLeft: "2px",
                                                        paddingBottom: "2px",
                                                        paddingRight: "1px",
                                                        marginTop: "10px",
                                                        marginLeft: "4px",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="col-sm-7"
                                            style={{
                                                margin: "1px 0 2px 2px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-evenly",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: "700",
                                                    textAlign: "center",
                                                    textTransform: "capitalize",
                                                }}
                                                className="text-center name"
                                            >
                                                {getFirstAndLastNames(person?.name?.toLowerCase())}
                                            </div>
                                            <div
                                                className="text-center info"
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "700",
                                                    fontStyle: "normal",
                                                    textAlign: "justify",
                                                }}
                                            >
                                                {/* <p className='role' style={{fontWeight: '600',textTransform:'capitalize'}}>{person.role}</p> */}
                                                <p
                                                    className="company"
                                                    style={{ fontSize: "14px", fontStyle: "italic" }}
                                                >
                                                    {person.role ? person.role.substring(0, 80) : null}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={handleClosePrint} color="secondary">
                            cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={async () => {
                                await updateCredential();
                                handlePrint();
                            }}
                            color="primary"
                        >
                            Imprimir
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    const confirmDialog = (
        <>
            <Dialog fullScreen onClose={handleClose} open={dialogOpen}>
                <ContainerBox className="content">
                    <DialogContent style={{ display: "flex", flexDirection: "column", gap: "50px" }}>
                        <Label size="medium" color="dark" align="center" weight="500" padding="5px 0">
                            Aproveite o Evento!
                        </Label>
                        <div
                            style={{
                                display: "inline-block",
                                padding: "50px",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                boxShadow: "2px 2px 12px rgba(0,0,0,0.1)",
                                fontFamily: "Arial, sans-serif",
                            }}
                        >
                            <p style={{ margin: 0, fontWeight: "bold", fontSize: "18px" }}>{person.name}</p>
                            <p style={{ margin: "20px 0" }}>{person.email}</p>
                            <p style={{ margin: 0, color: "#555" }}>{person.role}</p>
                        </div>
                        <div></div>
                    </DialogContent>
                    {/* <Divider/>
                    <Label
                        size='small'
                        color='dark'
                        align='center'
                        font='Roboto'
                        padding='10px 0 30px'
                    >
                        Posição no evento:
                    </Label>
                    <SeatPicker
                        rows={rows}
                        maxReservableSeats={event.lines * event.columns}
                        alpha={false}
                        visible
                        selectedByDefault
                        tooltipProps={{multiline: true}}
                    /> */}
                    <Divider />
                    <DialogActions>
                        <Btn
                            onClick={(e) => setDialogPrintOpen({ dialogPrintOpen: true })}
                            color="success"
                            format="solid"
                            style={{ maxWidth: "50%" }}
                        >
                            Imprimir Tag
                        </Btn>
                        <Btn onClick={handleClose} color="error" format="solid" style={{ maxWidth: "50%" }}>
                            Fechar
                        </Btn>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    const vip = (
        <ListItemIcon>
            <Star />
        </ListItemIcon>
    );
    const showed = (
        <ListItemIcon>
            <Check />
        </ListItemIcon>
    );

    const renderResult = () => {
        if (props.data.people.length > 0) {
            return props.data.people.map((person) => {
                return (
                    <ListItem
                        button
                        onClick={(event) => onClick(event, person)}
                        style={{ alignItems: "center", justifyContent: "space-between" }}
                    >
                        <ListItemText primary={`${person.name}`} secondary={`${person.role}`} />
                        {person.vip ? vip : null}
                        {person.status_id === SHOWED_UP_ID ? showed : null}
                    </ListItem>
                );
            });
        } else {
            return <Typography style={{ textAlign: "center" }}>Nenhum resultado encontrado</Typography>;
        }
    };

    return (
        <>
            {isLoading && <Loading />}
            {confirmDialog}
            {printDialog}
            <Container component="main" maxWidth="xs" style={{ background: "#ecf1f8" }}>
                <Content>
                    <Label size="medium" color="dark" align="center">
                        Resultado
                    </Label>
                    <List component="nav" style={{ width: "100%" }}>
                        {renderResult()}
                    </List>
                    <div className="content_button">
                        <Grid container>
                            <Button
                                className="button"
                                variant="contained"
                                color="secondary"
                                disableElevation
                                onClick={() => props.close()}
                            >
                                <CloseIcon />
                            </Button>
                        </Grid>
                    </div>
                </Content>
            </Container>
        </>
    );
};

export default TotemResult;
